import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Icon from "./Icon";
import joinClassNames from "../helpers/joinClassNames";
import { DEFAULT_DATE, DEFAULT_DATE_OUTPUT_FORMAT } from "../constants/date";

export const CustomDatePicker = ({
  date,
  onChange,
  className,
  inputClassName,
  placeholder = "Select date",
  maxDate = DEFAULT_DATE,
  minDate = "",
  dateFormat = DEFAULT_DATE_OUTPUT_FORMAT,
  showIcon = true
}) => {
  return (
    <section className={joinClassNames("position-relative", className)}>
      <DatePicker
        className={inputClassName}
        selected={date}
        onChange={onChange}
        minDate={minDate}
        maxDate={maxDate}
        dateFormat={dateFormat}
        placeholderText={placeholder}
      />
      {showIcon && <Icon className="react-datepicker__custom-icon" icon="datepicker"/>}
    </section>
  );
};